import { rewriteReportDomain } from "../../configs/environment";
import { getParams } from "../../utlis/helpers";
import { isWebView, postWebViewMessage } from "../../utlis/webViewBridge";

export const CLIENT_INOCHI = "inochi";
export const SESSION_STORAGE_KEY = "mmtSession";

export const getLocale = () => getParams().locale || "en";

export const encodeBase64 = (value) => {
  try {
    return window.btoa(unescape(encodeURIComponent(value)));
  } catch {
    return window.btoa(value);
  }
};

export const getSessionFromUrl = () => {
  const params = getParams();
  if (!params.accessToken || !params.staffId) return null;
  return {
    accessToken: params.accessToken,
    staffId: params.staffId,
    providerId: params.providerId || "",
    adminId: params.adminId || "",
    clientId: params.clientId || "",
    locale: params.locale || "en",
    client: params.client || CLIENT_INOCHI,
  };
};

export const getStoredSession = () => {
  const fromUrl = getSessionFromUrl();
  if (fromUrl) {
    setStoredSession(fromUrl);
    return fromUrl;
  }
  try {
    const stored = JSON.parse(
      sessionStorage.getItem(SESSION_STORAGE_KEY) || "null",
    );
    return stored?.accessToken ? stored : null;
  } catch {
    return null;
  }
};

export const setStoredSession = (session) => {
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
};

export const clearStoredSession = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
  sessionStorage.removeItem("userList");
  sessionStorage.removeItem("userIndex");
  sessionStorage.removeItem("testMModule");
};

export const sessionQuery = (session, extra = {}) => {
  const query = new URLSearchParams({
    staffId: session.staffId,
    accessToken: session.accessToken,
    locale: session.locale || getLocale(),
    providerId: session.providerId || "",
    adminId: session.adminId || "",
    clientId: session.clientId || "",
    client: session.client || CLIENT_INOCHI,
    tab: "metrics",
    hideNav: "true",
    ...extra,
  });
  return query.toString();
};

export const buildSessionPath = (path, session, extra = {}) =>
  `${path}?${sessionQuery(session, extra)}`;

export const buildDashboardUrl = (session, seniorId, quickJumpHash) => {
  const base = buildSessionPath("/person-dashboard", session, { seniorId });
  return quickJumpHash ? `${base}#${quickJumpHash}` : base;
};

export const buildActivityMonitoringUrl = (session, seniorId) =>
  buildSessionPath("/activity-monitoring", session, {
    seniorId,
    tab: "monitor",
  });

export const openAddTestPerson = (session, openModal) => {
  if (isWebView()) {
    postWebViewMessage("OPEN_ADD_TEST_PERSON");
    return;
  }
  openModal({ type: "add" });
};

export const openEditTestPerson = (session, seniorUuid, openModal) => {
  if (isWebView()) {
    postWebViewMessage("OPEN_EDIT_TEST_PERSON", { seniorUuid });
    return;
  }
  openModal({ type: "edit", seniorUuid });
};

export const openViewTestPerson = (session, seniorUuid, openModal) => {
  if (isWebView()) {
    postWebViewMessage("OPEN_VIEW_TEST_PERSON", { seniorUuid });
    return;
  }
  openModal({ type: "view", seniorUuid });
};

export const quickJumpToHash = (destination) =>
  String(destination || "").replace(/_/g, "-");

export const appendQueryParamsToUrl = (rawUrl, params) => {
  const [withoutHash, hash = ""] = String(rawUrl).split("#");
  const [base, query = ""] = withoutHash.split("?");
  const search = new URLSearchParams(query);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const hashSuffix = hash ? `#${hash}` : "";
  return `${base}?${search.toString()}${hashSuffix}`;
};

export const appendTabToUrl = (url, tab) =>
  appendQueryParamsToUrl(url, { tab });

export const normalizeReportUrl = (rawUrl, session) => {
  const replaced = String(rawUrl || "").replace(/reportv1/i, "reportv2");
  return appendQueryParamsToUrl(rewriteReportDomain(replaced), {
    isWebsite: "true",
    accessToken: session.accessToken,
    staffId: session.staffId,
    providerId: session.providerId,
    adminId: session.adminId,
    clientId: session.clientId,
    tab: "metrics",
    hideNav: "true",
    reportId:
      new URLSearchParams((replaced.split("?")[1] || "").split("#")[0]).get(
        "reportId",
      ) || "latest",
    appType:
      new URLSearchParams((replaced.split("?")[1] || "").split("#")[0]).get(
        "appType",
      ) || "sl",
    metrics:
      new URLSearchParams((replaced.split("?")[1] || "").split("#")[0]).get(
        "metrics",
      ) || "true",
  });
};

export const formatPersonName = (firstName, lastName, locale = getLocale()) =>
  locale === "en"
    ? `${firstName || ""} ${lastName || ""}`.trim()
    : `${lastName || ""} ${firstName || ""}`.trim();
